import { useOnboardingStore } from '@/store/onboardingStore';
import { TextureButton } from '@/components/ui/TextureButton';
import { Users, UserPlus } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export function ParentSetupScreen() {
    const { complete } = useOnboardingStore();
    const navigate = useNavigate();

    const handleComplete = async () => {
        await complete();
        navigate('/');
    };

    return (
        <div className="px-2 animate-fade-in-right text-center space-y-6 pt-8">
            <div className="w-16 h-16 bg-blue-500/20 rounded-2xl flex items-center justify-center mx-auto text-blue-400">
                <Users className="w-8 h-8" />
            </div>

            <div className="space-y-2">
                <h2 className="text-xl font-bold text-white">Parent Dashboard</h2>
                <p className="text-text-secondary text-sm">
                    Manage your athlete's training, schedule, and subscription from one place.
                </p>
            </div>

            <div className="bg-surface-card border border-white/10 p-6 rounded-2xl">
                <h3 className="font-bold text-white text-sm mb-4">What's Next?</h3>
                <ul className="space-y-3 text-left">
                    <li className="flex gap-2 text-xs text-text-muted">
                        <span className="text-gold-500">1.</span> Create your child's profile
                    </li>
                    <li className="flex gap-2 text-xs text-text-muted">
                        <span className="text-gold-500">2.</span> Set training goals
                    </li>
                    <li className="flex gap-2 text-xs text-text-muted">
                        <span className="text-gold-500">3.</span> Invite them to the app
                    </li>
                </ul>
            </div>

            <TextureButton onClick={handleComplete} className="w-full">
                Create Child Profile
            </TextureButton>
        </div>
    );
}

export function CoachSetupScreen() {
    const { complete } = useOnboardingStore();
    const navigate = useNavigate();

    const handleComplete = async () => {
        await complete();
        navigate('/');
    };

    return (
        <div className="px-2 animate-fade-in-right text-center space-y-6 pt-8">
            <div className="w-16 h-16 bg-gold-500/20 rounded-2xl flex items-center justify-center mx-auto text-gold-500">
                <UserPlus className="w-8 h-8" />
            </div>

            <div className="space-y-2">
                <h2 className="text-xl font-bold text-white">Coach Portal</h2>
                <p className="text-text-secondary text-sm">
                    Build your roster, assign workouts, and track team progress.
                </p>
            </div>

            <TextureButton onClick={handleComplete} className="w-full">
                Setup My Team
            </TextureButton>
        </div>
    );
}
